import { dismissNotificationPermissionsOverlay } from '../actions/overlayActions';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Layer } from 'office-ui-fabric-react/lib/Layer';
import { Overlay } from 'office-ui-fabric-react/lib/Overlay';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';

let styles = require('./AllowWebPushOverlay.scss');

@observer
export class AllowWebPushOverlay extends React.Component<{}, {}> {
    render() {
        return (
            <Layer>
                <Overlay isDarkThemed={true} onClick={dismissNotificationPermissionsOverlay}>
                    <div className={styles.guidance}>
                        <Icon iconName={'ChevronUp'} className={styles.chevron} />
                        <div className={styles.message}>{strings.webpushOverlayGuidance}</div>
                    </div>
                </Overlay>
                ,
            </Layer>
        );
    }
}
